import { isNative } from "./platform";
import { api } from "../api";

/**
 * FCM push registration. On native, requests notification permission, gets the
 * device token, and registers it with the API so the reminder sweep can push.
 * No-ops on web. Fails soft — a server hiccup just means the token registers on
 * the next login. Requires google-services.json in the Android build (see
 * apps/mobile README); until then registration silently gets no token.
 */
let currentToken: string | null = null;

export async function registerPush(): Promise<void> {
  if (!isNative()) return;
  const { PushNotifications } = await import("@capacitor/push-notifications");
  try {
    const perm = await PushNotifications.requestPermissions();
    if (perm.receive !== "granted") return;

    await PushNotifications.addListener("registration", async (t) => {
      currentToken = t.value;
      try {
        await api.post("/api/devices/register", { token: t.value, platform: "android" });
      } catch {
        /* server unreachable — retried on next login */
      }
    });
    await PushNotifications.addListener("registrationError", () => {
      /* FCM not configured yet (no google-services.json) — ignore */
    });

    await PushNotifications.register();
  } catch {
    /* push unavailable on this build — ignore */
  }
}

export async function unregisterPush(): Promise<void> {
  if (!isNative() || !currentToken) return;
  try {
    await api.post("/api/devices/unregister", { token: currentToken });
  } catch {
    /* ignore */
  }
  currentToken = null;
}
